// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var QuestionText$ReactHooksTemplate = require("./QuestionText.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var MultipleSelectOptions$ReactHooksTemplate = require("./MultipleSelectOptions.res.js");
var MultipleSelectDefaultForm$ReactHooksTemplate = require("./MultipleSelectDefaultForm.res.js");

function MultipleSelectForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var multipleSelect = props.multipleSelect;
  var match = React.useState(function (param) {
        
      });
  var setErrorMessage = match[1];
  var errorMessage = match[0];
  var match$1 = MultipleSelect$ReactHooksTemplate.representation(multipleSelect);
  var backGroundCss;
  switch (match$1) {
    case "NoBackground" :
    case "TropicalBreezeBackground" :
        backGroundCss = "bg-tropicalbreeze";
        break;
    case "BlackBackground" :
        backGroundCss = "bg-black bg-opacity-50";
        break;
    
  }
  var match$2 = OrganizationProfile$ReactHooksTemplate.name(props.client);
  switch (match$2) {
    case "bhima" :
    case "ncell" :
    case "nykaa" :
        break;
    default:
      return JsxRuntime.jsx(MultipleSelectDefaultForm$ReactHooksTemplate.make, {
                  multipleSelect: multipleSelect,
                  language: language,
                  mandatory: mandatory,
                  onChange: onChange,
                  borderCss: props.borderCss,
                  substitutionVariables: substitutionVariables
                });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionText$ReactHooksTemplate.make, {
                      text: MultipleSelect$ReactHooksTemplate.getTextTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: MultipleSelect$ReactHooksTemplate.getDescriptionTranslation(multipleSelect, SurveyLanguage$ReactHooksTemplate.name(language)),
                      mandatory: mandatory,
                      surveyTheme: props.surveyTheme,
                      substitutionVariables: substitutionVariables
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: $$Array.of_list(Belt_List.map(MultipleSelect$ReactHooksTemplate.nonEmptyChoices(multipleSelect), (function (choice) {
                                        return JsxRuntime.jsx(JsxRuntime.Fragment, {
                                                    children: Caml_option.some(JsxRuntime.jsx(MultipleSelectOptions$ReactHooksTemplate.make, {
                                                              choice: choice,
                                                              multipleSelect: multipleSelect,
                                                              onChange: onChange,
                                                              language: language,
                                                              setErrorMessage: setErrorMessage,
                                                              textInputClassName: " " + backGroundCss + " w-full border p-4 ",
                                                              checkBoxInputClassName: " p-2 border border-white-300 rounded-full flex w-3/4 small:w-full mb-2 ",
                                                              checkboxClassName: "checkbox",
                                                              containerClassName: "flex pb-2 "
                                                            }))
                                                  });
                                      }))),
                            className: "block mb-10-px"
                          }),
                      className: "flex flex-col"
                    }),
                mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                errorMessage !== undefined ? JsxRuntime.jsx("div", {
                        children: errorMessage,
                        className: "text-red-500 text-sm mt-1 text-left"
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "flex flex-col py-8 px-16 small:px-6"
            });
}

var make = MultipleSelectForm;

exports.make = make;
/* react Not a pure module */
